<template lang="pug">
  .component-client-action-buttons
    button.button.warning(v-if="!vehicle", type="button", v-on:click="remove") Delete
    button.button.warning(v-else, type="button", v-on:click="removeFromVehicle") Delete
</template>
<script type="text/babel">
  import KeplerBackofficeSdk from 'src/lib/kepler/backoffice'
  import MaggieHelper from "src/maggieHelper"

  export default {
    name: "InstructionButtons",
    components: {},
    data() {
      return {
        entity: null
      }
    },
    created() {
    },
    methods: {
      remove: function () {
        this.$confirm('Are you sure?', `Do you really want to <strong>Remove</strong> the <strong>IN${this.item.id} instruction?</strong>`, () => {
          KeplerBackofficeSdk.instructions.select(this.item).remove(() => {
            MaggieHelper.notification('delete-esit', "Instruction removed")
            window.location.reload()
          })
        })
      },
      removeFromVehicle: function () {
        this.$confirm('Are you sure?', `Do you really want to <strong>Remove</strong> the <strong>IN${this.item.id} instruction?</strong>`, () => {
          KeplerBackofficeSdk.vehicleInstructions.select(this.item).remove(() => {
            MaggieHelper.notification('delete-esit', "Instruction removed")
            window.location.reload()
          })
        })
      },
    },
    props: ['item', 'vehicle']
  }
</script>
<style lang="sass" rel="stylesheet/sass">

</style>



// WEBPACK FOOTER //
// InstructionButtons.vue?1cf67eae